import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { ChevronLeft, Wrench, Package } from 'lucide-react';
import CalibrationMainPage from '../../components/Calibration/CalibrationMainPage';
import MaterialsMainPage from '../../components/Materials/MaterialsMainPage';
import '../technical/HeatProfilePage.css';
import './CalibrationPage.css';

const TAB_ITEMS = [
    { id: 'calibration', label: 'Calibration', icon: <Wrench size={18} /> },
    { id: 'materials', label: 'Materials', icon: <Package size={18} /> },
];

const Tabs = ({ items, activeTabId, onTabClick }) => {
    return (
        <div className="calibration-tabs-container">
            <div className="calibration-tabs">
                {items.map((item) => (
                    <div
                        key={item.id}
                        className={`calibration-tab-item ${activeTabId === item.id ? 'active' : ''}`}
                        onClick={() => onTabClick(item.id)}
                    >
                        {item.icon}
                        {item.label}
                    </div>
                ))}
            </div>
        </div>
    );
};

const CalibrationPage = () => {
    const history = useHistory();
    const [activeTab, setActiveTab] = useState('calibration');

    const handleBackClick = () => {
        if (window.history.length > 1) {
            history.goBack();
        } else {
            history.push('/calibration-control');
        }
    };

    return (
        <div className="calibration-page">
            <div className="calibration-page-top-section">
                <div className="calibration-page-heading">
                    <a
                        href="#back"
                        onClick={(e) => {
                            e.preventDefault();
                            handleBackClick();
                        }}
                        className="calibration-page-back-link"
                    >
                        <div className="calibration-back-link">
                            <ChevronLeft size={16} /> Back To Calibration Control
                        </div>
                    </a>
                </div>
            </div>

            <Tabs
                items={TAB_ITEMS}
                activeTabId={activeTab}
                onTabClick={setActiveTab}
            />

            <div className="calibration-divider" style={{ marginTop: 0 }} />

            <div className="calibration-content-wrapper heat-profile-content-wrapper">
                {activeTab === 'calibration' ? (
                    <CalibrationMainPage embeddedInModernLayout />
                ) : (
                    <MaterialsMainPage embeddedInModernLayout />
                )}
            </div>
        </div>
    );
};

export default CalibrationPage;
